import React from 'react'
import { compose, pure } from 'recompose'
import styles from './siteNavDropdownComponent.scss'
import PropTypes from 'prop-types'

export function SiteNavDropdown (props) {
  // TODO: Remove styling for oncareerPathed invisible element, make invisible element not tab-accessible, make dropdown leave when tabindex leaves it

  return (
    <li
      className={[
        styles.relative,
        styles.dropdownMenuWrapper,
        props.isSubrouteActive && styles.active
      ].join(' ')}
    >
      <button
        className={[
          props.buttonClass,
          styles.navLinkDropdown,
          props.showDropdown ? styles.navLinkDropdownActive : null
        ].join(' ')}
        onClick={props.toggleDropdown}
        aria-haspopup='true'
        aria-expanded={props.showDropdown ? 'true' : 'false'}
      >
        <span className={[props.textClass].join(' ')}>
          {props.buttonLabel}
        </span>
        <span className={styles.caret} />
      </button>
      <ul
        className={[
          styles.dropdownMenu,
          props.showDropdown ? styles.display : styles.hide
        ].join(' ')}
      >
        {props.children}
        {props.showDropdown &&
          <li>
            <button
              className={styles.overlay}
              aria-label='close dropdown'
              onClick={props.toggleDropdown}
            >
              <span>Close Dropdown</span>
            </button>
          </li>}
      </ul>
    </li>
  )
}

SiteNavDropdown.propTypes = {
  showDropdown: PropTypes.bool.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  buttonClass: PropTypes.string,
  textClass: PropTypes.string,
  children: PropTypes.any.isRequired,
  isSubrouteActive: PropTypes.bool
}

export default compose(pure)(SiteNavDropdown)



// WEBPACK FOOTER //
// ./src/components/siteNavDropdown/siteNavDropdownComponent.js